import { render } from "./BrandWienerBezirkszeitung.vue?vue&type=template&id=fb57f9b6"
import script from "./BrandWienerBezirkszeitung.vue?vue&type=script&lang=ts"
export * from "./BrandWienerBezirkszeitung.vue?vue&type=script&lang=ts"

import "./BrandWienerBezirkszeitung.vue?vue&type=style&index=0&id=fb57f9b6&lang=scss"
script.render = render

export default script